export const getMetadataItemByKey = (key: string, metadata?: MetaData[]) => {
  return metadata?.find((item) => item.key === key);
};
